import { Image } from "primereact/image";
import img1 from "../../../assets/images/temp2.png";
import { InputTextarea } from "primereact/inputtextarea";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import AtkLoader from "../../../AtlaskitControls/AtkLoader";
import Base64Image from "./Base64Image";

export default function Description(props: any) {
  const [isOverviewEditing, setIsOverviewEditing] = useState(false);
  const [isAboutUsEditing, setIsAboutUsEditing] = useState(false);
  const [isVisionEditing, setIsVisionEditing] = useState(false);
  const [isMissionEditing, setIsMissionEditing] = useState(false);
  const toast: any = useRef("");
  const navigate = useNavigate();
  useEffect(() => {}, [props]);

  const handleCancel = () => {
    setIsOverviewEditing(false);
    setIsAboutUsEditing(false);
    setIsMissionEditing(false);
    setIsVisionEditing(false);
  };
  return (
    <>
      <Toast ref={toast} />

      <div className="container p-0 border ">
        <div className="  w-100" style={{}}>
          <div className="row g-0 mx-auto">
            <div className="col-lg-6 col-md-6 col-sm-12 col-12 px-4 d-flex justify-content-lg-between justify-content-center align-items-center bg-white text-center text-md-start">
              <Base64Image imageUrl={props.logoURL || ""} className="rounded mt-1" alt="Insurance Image" height="80px" />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12 p-1 d-flex flex-column flex-md-row justify-content-md-end align-items-center text-muted small text-center text-md-end">
              {props.websiteurl}
            </div>

            <div className="col-12 d-flex  align-items-center px-4 py-1 " style={{ backgroundColor: `${props.primaryColor}`, color: "#fff" }}>
              <div className="row w-100 mx-auto">
                <div className="col-lg-7 col-md-7 col-sm-7 col-12">
                  <div className="d-flex align-items-center pb-2 my-4" style={{ borderBottom: "1px solid #fff", paddingTop: "5rem" }}>
                    <h4 className="fw-bold m-0">Company Overview</h4>

                    {props.isEditable && !props.isGeneratingPdf && (
                      <>
                        {!isOverviewEditing ? (
                          <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsOverviewEditing(true)} />
                        ) : (
                          <span className="text-12 d-flex align-items-center">
                            {props.saveLoading ? (
                              <div className="d-inline-flex align-items-center">
                                <AtkLoader />
                              </div>
                            ) : (
                              <>
                                <i
                                  className="fa fa-check mx-2 show-cursor text-success"
                                  title="Save"
                                  onClick={() => {
                                    setIsOverviewEditing(false);
                                    props.onTemplateDetailsSave();
                                  }}
                                />
                                <i
                                  className="fa fa-times show-cursor text-danger"
                                  title="Cancel"
                                  onClick={() => {
                                    setIsOverviewEditing(false);
                                    props.onCancelTemplateDetailsToSave();
                                  }}
                                />
                              </>
                            )}
                          </span>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 d-flex flex-column align-items-center px-3 py-1 bg-white">
              <div className="row w-100 mx-auto position-relative">
                <div className="col-lg-7 col-md-7 col-sm-7 col-12 mb-4 " style={{ minHeight: "250px" }}>
                  <span className=" text-12">
                    {isOverviewEditing ? (
                      <InputTextarea value={props.companyOverview} onChange={props.onCompanyOverviewChange} autoResize className="w-100 mb-3" />
                    ) : (
                      <p className="mb-1 mt-2 text-12 ">{props.companyOverview}</p>
                    )}
                  </span>
                  <h6 className="fw-bold pb-2 mt-3" style={{ borderBottom: "1px solid black" }}>
                    About us{" "}
                    {props.isEditable && !props.isGeneratingPdf ? (
                      <>
                        {!isAboutUsEditing ? (
                          <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsAboutUsEditing(true)} />
                        ) : (
                          <span className="text-12 ">
                            {isAboutUsEditing && props.saveLoading ? (
                              <div className="d-inline-flex align-items-center">
                                <AtkLoader />
                              </div>
                            ) : (
                              <i
                                className="fa fa-check mx-2 show-cursor text-success"
                                title="Save"
                                onClick={() => {
                                  setIsAboutUsEditing(false);
                                  props.onTemplateDetailsSave();
                                }}
                              />
                            )}
                            <i
                              className="fa fa-times show-cursor text-danger"
                              title="Cancel"
                              onClick={() => {
                                setIsAboutUsEditing(false);
                                props.onCancelTemplateDetailsToSave();
                              }}
                            />
                          </span>
                        )}
                      </>
                    ) : null}
                  </h6>
                  <span className=" text-12">
                    {isAboutUsEditing ? (
                      <InputTextarea value={props.aboutUs} onChange={props.onAboutUsChange} autoResize className="w-100" />
                    ) : (
                      <p className="mb-1 text-12">{props.aboutUs}</p>
                    )}
                  </span>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-5 col-0 overview-img-block position-relative">
                  <div className="position-absolute" style={{ top: "-82px", right: "15px" }}>
                    <div
                      style={{
                        position: "absolute",
                        left: "-14px",
                        bottom: "10%",
                        width: "14px",
                        height: "195px",
                        backgroundColor: props.secondaryColor,
                      }}
                    ></div>

                    <Image src={img1} alt="Insurance" className="rounded" height="320px"/>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 d-flex flex-column align-items-center px-3 py-5 bg-light">
              <div className="row w-100 mx-auto">
                <div className="col-6 mb-4 ">
                  <h6 className="pb-2" style={{ borderBottom: "1px solid black" }}>
                    Vision{" "}
                    {props.isEditable && !props.isGeneratingPdf ? (
                      <>
                        {!isVisionEditing ? (
                          <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsVisionEditing(true)} />
                        ) : (
                          <span className="text-12 ">
                            {isVisionEditing && props.saveLoading ? (
                              <div className="d-inline-flex align-items-center">
                                <AtkLoader />
                              </div>
                            ) : (
                              <i
                                className="fa fa-check mx-2 show-cursor text-success"
                                title="Save"
                                onClick={() => {
                                  setIsVisionEditing(false);
                                  props.onTemplateDetailsSave();
                                }}
                              />
                            )}
                            <i
                              className="fa fa-times show-cursor text-danger"
                              title="Cancel"
                              onClick={() => {
                                setIsVisionEditing(false);
                                props.onCancelTemplateDetailsToSave();
                              }}
                            />
                          </span>
                        )}
                      </>
                    ) : null}
                  </h6>
                  <span className=" text-12">
                    {isVisionEditing ? (
                      <InputTextarea value={props.vision} onChange={props.onVisionChange} autoResize className="w-100" />
                    ) : (
                      <p className="mb-1 text-12">{props.vision}</p>
                    )}
                  </span>
                </div>
                <div className="col mb-4 ">
                  <h6 className="pb-2" style={{ borderBottom: "1px solid black" }}>
                    Mission{" "}
                    {props.isEditable && !props.isGeneratingPdf ? (
                      <>
                        {!isMissionEditing ? (
                          <i className="fa fa-pencil text-12 ms-2 show-cursor" title="Edit" onClick={() => setIsMissionEditing(true)} />
                        ) : (
                          <span className="text-12 ">
                            {isMissionEditing && props.saveLoading ? (
                              <div className="d-inline-flex align-items-center">
                                <AtkLoader />
                              </div>
                            ) : (
                              <i
                                className="fa fa-check mx-2 show-cursor text-success"
                                title="Save"
                                onClick={() => {
                                  setIsMissionEditing(false);
                                  props.onTemplateDetailsSave();
                                }}
                              />
                            )}
                            <i
                              className="fa fa-times show-cursor text-danger"
                              title="Cancel"
                              onClick={() => {
                                setIsMissionEditing(false);
                                props.onCancelTemplateDetailsToSave();
                              }}
                            />
                          </span>
                        )}
                      </>
                    ) : null}
                  </h6>
                  <span className=" text-12">
                    {isMissionEditing ? (
                      <InputTextarea value={props.mission} onChange={props.onMissionChange} autoResize className="w-100" />
                    ) : (
                      <p className="mb-1 text-12">{props.mission}</p>
                    )}
                  </span>
                </div>
              </div>
              {props.teamMembers && props.teamMembers.length > 0 && (
                <div className="col-12 d-flex flex-column align-items-center px-3 py-5 bg-white">
                  <div className="row w-100 mx-auto">
                    <h6 className="fw-bold fs-5 mb-4" style={{ color: props.primaryColor }}>
                      Team Members
                    </h6>
                    {props.teamMembers.map((member: any, index: number) => (
                      <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-12 text-center mb-4">
                        <div className="position-relative card rounded-0" style={{ minHeight: "200px" }}>
                          <div
                            className="mb-3 mt-4 fw-bold mx-auto bg-light rounded-circle fs-3 d-flex justify-content-center align-items-center"
                            style={{
                              color: props.secondaryColor,
                              //  padding: "10px 15px",
                              width: "60px",
                              height: "60px",
                              overflow: "hidden",
                            }}
                          >
                            {member.profilePhoto ? (
                              <Base64Image imageUrl={member.profilePhoto || ""} className="qp-profile-photo" alt="Insurance Image" height="100%" />
                            ) : // <img
                            //   src={member.profilePhoto}
                            //   alt={member.name}
                            //   style={{
                            //     width: "100%",
                            //     height: "100%",
                            //     objectFit: "cover",
                            //     borderRadius: "50%",
                            //   }}
                            // />
                            member.name ? (
                              member.name
                                .split(" ")
                                .map((word: any) => word[0])
                                .slice(0, 2)
                                .join("")
                            ) : (
                              "New"
                            )}
                          </div>
                          <div className="text-light mb-3">
                            <h6 className="mb-1" style={{ color: props.primaryColor }}>
                              {member.name}
                            </h6>
                            <p className="text-12" style={{ color: props.primaryColor }}>
                              {member.role}
                            </p>
                          </div>
                          <div
                            className="position-absolute"
                            style={{ width: "70%", height: "8px", bottom: "-4px", left: "15%", backgroundColor: props.secondaryColor }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div
            className="position-relative text-center text-light small mt-3 border-top p-4 w-100"
            style={{ backgroundColor: `${props.primaryColor}`, color: "#fff" }}
          >
            <div
              className="position-absolute  "
              style={{ width: "70%", height: "14px", top: "0px", left: "15%", backgroundColor: `${props.secondaryColor}` }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
}
